import axios from "axios";
import {
  Lead_Service_URL,
  Master_Service_URL,
  Branch_Location_Pincode_URL,
  Branch_Gst_Verification_URL,
  Partner_Service_URL,
  User_Service_URL,
  Location_Service_URL,
  Applicant_Service,
  System_URL,
} from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
export const RESET_ADD_LEAD_ID = "RESET_ADD_LEAD_ID";
export const LeadMasterListActions = {
  LEAD_MASTER_LIST_SUCCESS: "LEAD_MASTER_LIST_SUCCESS",
  LEAD_MASTER_LIST_ERROR: "LEAD_MASTER_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getRelationshipDetails(props) {
  const { access_token } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_URL}/getAll/RelationshipMastersDTO`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        console.log("line92");
        if (err.response) {
          return err.response;
        }
      });
}

export function getAddLeadMasterList(props) {
  const { access_token } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Location_Service_URL}/getAll/Countries`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getLeadMasterListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getLeadMasterListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getLeadMasterListError(err));
          return err.response;
        }
      });
}

export function getLeadMasterListError(error) {
  return {
    type: LeadMasterListActions.LEAD_MASTER_LIST_ERROR,
    payload: error,
  };
}

export function getLeadMasterListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: LeadMasterListActions.LEAD_MASTER_LIST_SUCCESS,
      payload: props,
    });
  };
}

export const searchUniversityDetailActions = {
  SEARCH_UNIVERSITY_DETAIL_LOADING: "SEARCH_UNIVERSITY_DETAIL_LOADING",
  SEARCH_UNIVERSITY_DETAIL_SUCCESS: "SEARCH_UNIVERSITY_DETAIL_SUCCESS",
  SEARCH_UNIVERSITY_DETAIL_ERROR: "SEARCH_UNIVERSITY_DETAIL_ERROR",
};

export const searchUniversityDetails =
  (props) => async (dispatch, getState) => {
    const access_token = props.access_token ?? getState()?.auth?.idToken;

    const { params } = props;

    dispatch(SearchUniversityDetailLoading(true));

    return axios({
      method: "post",
      url: `${Master_Service_URL}/search/universityByCountryId?`,
      headers: {
        authorization: "Bearer " + access_token,
      },
      params: params,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(SearchUniversityDetailSuccess(response.data));
          return response;
        } else if (response.status === 401) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SearchUniversityDetailError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(SearchUniversityDetailError(err));
          return err.response;
        }
      });
  };

export const SearchUniversityDetailLoading = () => {
  return {
    type: searchUniversityDetailActions.SEARCH_UNIVERSITY_DETAIL_LOADING,
  };
};

export const SearchUniversityDetailSuccess = (props) => {
  return {
    type: searchUniversityDetailActions.SEARCH_UNIVERSITY_DETAIL_SUCCESS,
    payload: props,
  };
};

export const SearchUniversityDetailError = (props) => {
  return {
    type: searchUniversityDetailActions.SEARCH_UNIVERSITY_DETAIL_ERROR,
    payload: props,
  };
};

export const searchCollegeDetailActions = {
  SEARCH_COLLEGE_DETAIL_LOADING: "SEARCH_COLLEGE_DETAIL_LOADING",
  SEARCH_COLLEGE_DETAIL_SUCCESS: "SEARCH_COLLEGE_DETAIL_SUCCESS",
  SEARCH_COLLEGE_DETAIL_ERROR: "SEARCH_COLLEGE_DETAIL_ERROR",
};

export const searchCollegeDetails = (props) => async (dispatch, getState) => {
  const access_token = props.access_token ?? getState()?.auth?.idToken;

  const { params } = props;

  dispatch(SearchCollegeDetailLoading(true));

  return axios({
    method: "post",
    url: `${Master_Service_URL}/search/instituteByCountryIdAndUniversityId?`,
    headers: {
      authorization: "Bearer " + access_token,
    },
    params: params,
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(SearchCollegeDetailSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(SearchCollegeDetailError(error));
        throw error;
      }
    })
    .catch((err) => {
      if (err.response) {
        dispatch(SearchCollegeDetailError(err));
        return err.response;
      }
    });
};

export const SearchCollegeDetailLoading = () => {
  return {
    type: searchCollegeDetailActions.SEARCH_COLLEGE_DETAIL_LOADING,
  };
};

export const SearchCollegeDetailSuccess = (props) => {
  return {
    type: searchCollegeDetailActions.SEARCH_COLLEGE_DETAIL_SUCCESS,
    payload: props,
  };
};

export const SearchCollegeDetailError = (props) => {
  return {
    type: searchCollegeDetailActions.SEARCH_COLLEGE_DETAIL_ERROR,
    payload: props,
  };
};

export const searchCourseDetailActions = {
  SEARCH_COURSE_DETAIL_LOADING: "SEARCH_COURSE_DETAIL_LOADING",
  SEARCH_COURSE_DETAIL_SUCCESS: "SEARCH_COURSE_DETAIL_SUCCESS",
  SEARCH_COURSE_DETAIL_ERROR: "SEARCH_COURSE_DETAIL_ERROR",
};

export function searchCourseDetail(props) {
  const { access_token, params } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
      },
      url: `${Master_Service_URL}/search/Course`,

      params: params,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(SearchCourseDetailSuccess(response.data));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(SearchCourseDetailError(error));
          throw error;
        }
      })
      .catch((err) => {
        dispatch(SearchCourseDetailError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else if (!err.response) {
          // console.log(err);
        }
      });
}

export function SearchCourseDetailError(error) {
  return {
    type: searchCourseDetailActions.SEARCH_COURSE_DETAIL_ERROR,
    payload: error,
  };
}

export function SearchCourseDetailSuccess(props) {
  return {
    type: searchCourseDetailActions.SEARCH_COURSE_DETAIL_SUCCESS,
    payload: props,
  };
}

export function SearchCourseDetailLoading(props) {
  return {
    type: searchCourseDetailActions.SEARCH_COURSE_DETAIL_LOADING,
    payload: props,
  };
}

export const pincodeListActions = {
  PINCODE_LIST: "PINCODE_LIST",
  PINCODE_LIST_SUCCESS: "PINCODE_LIST_SUCCESS",
  PINCODE_LIST_ERROR: "PINCODE_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getPincodeOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url:
        `${Branch_Location_Pincode_URL}/search/Pincode?pincode=` + inputValue,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPincodeListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPincodeListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPincodeListError(err));
          return err.response;
        }
      });
}

export function getPincodeListRequest() {
  return {
    type: pincodeListActions.PINCODE_LIST,
    isPosting: true,
  };
}
export function getPincodeListError(error) {
  return {
    type: pincodeListActions.PINCODE_LIST_ERROR,
    payload: error,
  };
}

export function getPincodeListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pincodeListActions.PINCODE_LIST_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByAreaActions = {
  GET_BRANCH_LOCATION_BY_AREA: "GET_BRANCH_LOCATION_BY_AREA",
  GET_BRANCH_LOCATION_BY_AREA_SUCCESS: "GET_BRANCH_LOCATION_BY_AREA_SUCCESS",
  GET_BRANCH_LOCATION_BY_AREA_ERROR: "GET_BRANCH_LOCATION_BY_AREA_ERROR",
  LOGOUT: "LOGOUT",
};
export function getBranchLocationByArea(props) {
  const { access_token, url, pincode, data } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincode=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByAreaSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByAreaError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByAreaError(err));
          return err.response;
        } else {
        }
      });
}

export function getLocMasterByAreaRequest() {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA,
    isPosting: true,
  };
}
export function getBranchLocationByAreaError(error) {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_ERROR,
    payload: error,
  };
}

export function getBranchLocationByAreaSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByPincodeActions = {
  GET_BRANCH_LOCATION_BY_PINCODE: "GET_BRANCH_LOCATION_BY_PINCODE",
  GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS:
    "GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS",
  GET_BRANCH_LOCATION_BY_PINCODE_ERROR: "GET_BRANCH_LOCATION_BY_PINCODE_ERROR",
  LOGOUT: "LOGOUT",
};

export function getBranchLocationByPincode(props) {
  const { access_token, url, data, pincode } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincodeId=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByPincodeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByPincodeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByPincodeError(err));
          return err.response;
        }
      });
}

export function getBranchLocationByPincodeRequest() {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE,
    isPosting: true,
  };
}
export function getBranchLocationByPincodeError(error) {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_ERROR,
    payload: error,
  };
}

export function getBranchLocationByPincodeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS,
      payload: props,
    });
  };
}

export const sideBarBranchActions = {
  SIDE_BAR_BRANCH_SUCCESS: "SIDE_BAR_BRANCH_SUCCESS",
  SIDE_BAR_BRANCH_ERROR: "SIDE_BAR_BRANCH_ERROR",
};

export function getSideBarBranch(props) {
  const { access_token, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Branch_Gst_Verification_URL}/getAllBranchDetailsByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(SideBarBranchSuccess(response.data));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SideBarBranchError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        dispatch(SideBarBranchError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else {
        }
      });
}

export function SideBarBranchError(error) {
  return {
    type: sideBarBranchActions.SIDE_BAR_BRANCH_ERROR,
    payload: error,
  };
}

export function SideBarBranchSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: sideBarBranchActions.SIDE_BAR_BRANCH_SUCCESS,
      payload: props,
    });
  };
}

export const searchPartnerNameActions = {
  SEARCH_PARTNER_NAME_LOADING: "SEARCH_PARTNER_NAME_LOADING",
  SEARCH_PARTNER_NAME_SUCCESS: "SEARCH_PARTNER_NAME_SUCCESS",
  SEARCH_PARTNER_NAME_ERROR: "SEARCH_PARTNER_NAME_ERROR",
};

export function searchPartnerNameDetail(props) {
  const { access_token, params, partnerName } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
      },
      url: `${Partner_Service_URL}/search/partners?partnerFirmName=${partnerName}`,

      // params: params,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(searchPartnerNameSuccess(response.data));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(searchPartnerNameError(error));
          throw error;
        }
      })
      .catch((err) => {
        dispatch(searchPartnerNameError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else if (!err.response) {
          // console.log(err);
        }
      });
}

export function searchPartnerNameError(error) {
  return {
    type: searchPartnerNameActions.SEARCH_PARTNER_NAME_ERROR,
    payload: error,
  };
}

export function searchPartnerNameSuccess(props) {
  return {
    type: searchPartnerNameActions.SEARCH_PARTNER_NAME_SUCCESS,
    payload: props,
  };
}

export function searchPartnerNameLoading(props) {
  return {
    type: searchPartnerNameActions.SEARCH_PARTNER_NAME_LOADING,
    payload: props,
  };
}

export const saveAddLeadActions = {
  SAVE_ADD_LEAD_SUCCESS: "SAVE_ADD_LEAD_SUCCESS",
  SAVE_ADD_LEAD_ERROR: "SAVE_ADD_LEAD_ERROR",
};

export function saveAddLeadDetails(props) {
  const { access_token, values } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/save/Lead/Partner`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveAddLeadSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveAddLeadError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveAddLeadError(err));
          return err.response;
        }
      });
}

export function saveAddLeadError(error) {
  return {
    type: saveAddLeadActions.SAVE_ADD_LEAD_ERROR,
    payload: error,
  };
}

export function saveAddLeadSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveAddLeadActions.SAVE_ADD_LEAD_SUCCESS,
      payload: props,
    });
  };
}

export const getAllEditUserDetailsActions = {
  GETALL_EDIT_USER_SUCCESS: "GETALL_EDIT_USER_SUCCESS",
  GETALL_EDIT_USER_ERROR: "GETALL_EDIT_USER_ERROR",
};

export function getAllEditUserDetails(props) {
  const { access_token, values, userId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/get/UserMaster/ByUserId?userId=${userId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAllEditUserSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAllEditUserError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getAllEditUserError(err));
          return err.response;
        }
      });
}

export function getAllEditUserError(error) {
  return {
    type: getAllEditUserDetailsActions.GETALL_EDIT_USER_ERROR,
    payload: error,
  };
}

export function getAllEditUserSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getAllEditUserDetailsActions.GETALL_EDIT_USER_SUCCESS,
      payload: props,
    });
  };
}

export function resetAddLeadId() {
  return {
    type: RESET_ADD_LEAD_ID,
  };
}

export const getEditLeadActions = {
  GET_EDIT_LEAD_SUCCESS: "GET_EDIT_LEAD_SUCCESS",
  GET_EDIT_LEAD_ERROR: "GET_EDIT_LEAD_ERROR",
};

export function getEditLeadDetails(props) {
  const { access_token, leadId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/get/LeadDetails?leadId=${leadId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getEditLeadSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getEditLeadError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getEditLeadError(err));
          return err.response;
        }
      });
}

export function getEditLeadError(error) {
  return {
    type: getEditLeadActions.GET_EDIT_LEAD_ERROR,
    payload: error,
  };
}

export function getEditLeadSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getEditLeadActions.GET_EDIT_LEAD_SUCCESS,
      payload: props,
    });
  };
}

export function deleteCoApp(props) {
  const { access_token, applicantId } = props;
  console.log("line 765", Applicant_Service);

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Applicant_Service}/deactivateReactivateLeadCoapplicant?applicantId=${applicantId}&active=false`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getEditLeadSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getEditLeadError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getEditLeadError(err));
          return err.response;
        }
      });
}

export const CourseLoanActions = {
  COURSE_TYPE_NAME: "COURSE_TYPE_NAME",
  COURSE_TYPE_NAME_SUCCESS: "COURSE_TYPE_NAME_SUCCESS",
  COURSE_TYPE_NAME_ERROR: "COURSE_TYPE_NAME_ERROR",
};

export function getCourseTypeName(props) {
  const { access_token, name, url } = props;
  let endpoint = `${System_URL}/get/${url}/${name}`;

  return (dispatch) =>
    axios({
      method: "get",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: endpoint,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getCourseTypeNameSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getCourseTypeNameError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getCourseTypeNameError(err));
          return err.response;
        }
      });
}

export function getCourseTypeNameError(error) {
  return {
    type: CourseLoanActions.COURSE_TYPE_NAME_ERROR,
    payload: error,
  };
}

export function getCourseTypeNameSuccess(response) {
  return {
    type: CourseLoanActions.COURSE_TYPE_NAME_SUCCESS,
    payload: response,
  };
}

export const BUCKET_CHANGE = "BUCKET_CHANGE";

export const bucketChange = (bucketType) => ({
  type: BUCKET_CHANGE,
  payload: bucketType,
});
